var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#03122B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 9.70973C21.91 9.31973 21.28 9.31973 20.89 9.70973L16 14.5897L11.11 9.69973C10.72 9.30973 10.09 9.30973 9.7 9.69973C9.31 10.0897 9.31 10.7197 9.7 11.1097L14.59 15.9997L9.7 20.8897C9.31 21.2797 9.31 21.9097 9.7 22.2997C10.09 22.6897 10.72 22.6897 11.11 22.2997L16 17.4097L20.89 22.2997C21.28 22.6897 21.91 22.6897 22.3 22.2997C22.69 21.9097 22.69 21.2797 22.3 20.8897L17.41 15.9997L22.3 11.1097C22.68 10.7297 22.68 10.0897 22.3 9.70973Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRound);
export default __webpack_public_path__ + "static/media/closeRound.f2b2e863098ce676fead48d112f43aa9.svg";
export { ForwardRef as ReactComponent };